import {Injectable} from '@angular/core';

@Injectable()
export class ComposingService {
    isComposing = false;

    constructor() {
        document.addEventListener('compositionstart', (event: any) => {
            this.isComposing = true;
        });
        document.addEventListener('compositionend', (event: any) => {
            this.isComposing = false;
        });
    }
}
